import styled from 'styled-components';

export const TooltipStyled = styled.div`
  width: 100%;
  background-color: #e6dec9;
  padding: 8px;
  display: flex;
  align-items: flex-start;
  border-radius: 4px;
`;

export const TooltipIcon = styled.img`
  margin-right: 8px;
`;

export const TooltipBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
